// Data Classification Hub Configuration
export const UPLOAD_CONFIG = {
  SUPPORTED_FORMATS: [".pdf", ".doc", ".docx", ".png", ".jpg", ".jpeg"],
  MAX_FILE_SIZE: 10 * 1024 * 1024, // 10MB
  MAX_FILES: 50,
  CHUNK_SIZE: 1024 * 1024 // 1MB chunks
} as const;

export const PROCESS_STEPS = [
  {
    step: 1,
    icon: "Upload",
    title: "Upload",
    description: "Import from local or cloud",
    color: "#2563eb",
    isActive: true
  },
  {
    step: 2,
    icon: "CheckCircle",
    title: "Classify",
    description: "Auto-categorize documents",
    color: "#059669",
    isActive: false
  },
  {
    step: 3,
    icon: "FileText",
    title: "Extract",
    description: "Pull key information",
    color: "#7c3aed",
    isActive: false
  }
] as const;

// Cloud Sources Configuration
export const CLOUD_SOURCES = [
  {
    id: "sharepoint",
    name: "SharePoint Online",
    icon: "Business",
    color: "#2563eb",
    description: "Connect to SharePoint sites and libraries",
    connectionType: "oauth"
  },
  {
    id: "azureblob",
    name: "Azure Blob Storage",
    icon: "CloudUpload",
    color: "#06b6d4",
    description: "Import from Azure storage containers",
    connectionType: "api-key"
  },
  {
    id: "googledrive",
    name: "Google Drive",
    icon: "Folder",
    color: "#059669",
    description: "Access files from Google Drive folders",
    connectionType: "oauth"
  },
  {
    id: "onedrive",
    name: "OneDrive",
    icon: "Work",
    color: "#7c3aed",
    description: "OneDrive for Business or Personal",
    connectionType: "oauth"
  },
  {
    id: "awss3",
    name: "AWS S3",
    icon: "Storage",
    color: "#ea580c",
    description: "Import from S3 buckets",
    connectionType: "credentials"
  },
  {
    id: "dropbox",
    name: "Dropbox",
    icon: "Archive",
    color: "#4f46e5",
    description: "Access Dropbox files and folders",
    connectionType: "oauth"
  }
] as const;

export const CLOUD_CONFIG = {
  MAX_ITEMS_PER_REQUEST: 100,
  SUPPORTED_CLOUD_FORMATS: [
    ".pdf",
    ".doc",
    ".docx",
    ".png",
    ".jpg",
    ".jpeg",
    ".txt",
    ".xls",
    ".xlsx"
  ],
  CONNECTION_TIMEOUT: 30000, // 30 seconds
  IMPORT_BATCH_SIZE: 10
} as const;

// Category Overview Configuration
export const CATEGORY_CONFIG = {
  DEFAULT_COLORS: [
    "#2563eb", // Blue
    "#059669", // Green
    "#7c3aed", // Purple
    "#ea580c", // Orange
    "#dc2626", // Red
    "#0891b2", // Cyan
    "#7c2d12", // Brown
    "#be123c" // Pink
  ],
  MAX_CATEGORIES_DISPLAY: 12,
  CONFIDENCE_THRESHOLD: 0.75,
  DEFAULT_CATEGORY_NAME: "Uncategorized"
} as const;

export const DEFAULT_CATEGORIES = [
  {
    id: "contract",
    name: "Contract",
    color: "#059669",
    description: "Financial reports, invoices, receipts"
  },
  {
    id: "invoice",
    name: "Invoice",
    color: "#7c3aed",
    description: "Legal contracts, service agreements, partnerships"
  },
  {
    id: "receipt",
    name: "Receipt",
    color: "#ea580c",
    description: "Purchase orders, invoices, billing documents"
  },
  {
    id: "report",
    name: "Report",
    color: "#2563eb",
    description: "Transaction receipts, expense records"
  },
  {
    id: "agreement",
    name: "Agreement",
    color: "#dc2626",
    description: "Business reports, quarterly analysis, assessments"
  },
  {
    id: "unknown",
    name: "Unknown",
    color: "#6b7280",
    description: "Miscellaneous business documents"
  }
] as const;
